import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthLayoutComponent } from "./shared/components/layouts/auth-layout/auth-layout.component";
import { AuthGaurd } from "./shared/services/auth.gaurd";
import { BlankLayoutComponent } from "./shared/components/layouts/blank-layout/blank-layout.component";
import { AdminLayoutSidebarCompactComponent } from "./shared/components/layouts/admin-layout-sidebar-compact/admin-layout-sidebar-compact.component";
import { AdminLayoutSidebarLargeComponent } from "./shared/components/layouts/admin-layout-sidebar-large/admin-layout-sidebar-large.component";
import { UserProfileComponent } from "./views/pages/user-profile/user-profile.component";




const date = new Date();
const adminRoutes: Routes = [
  {
    path: "dashboard",
    loadChildren: () => import("./views/dashboard/dashboard.module").then((m) => m.DashboardModule),
  },
  {
    path: "settings",
    loadChildren: () => import("./views/settings/settings.module").then((m) => m.SettingsModule),
  },
 
  {
    path: "invoice",
    loadChildren: () => import("./views/inventory/inventory.module").then((m) => m.InventoryModule),
  },
  {
    path: "user",
    loadChildren: () => import("./views/pages/pages.module").then((m) => m.PagesModule),
  },
 
  
];

const routes: Routes = [
  {
    path: "",
    redirectTo: "invoice",
    pathMatch: "full",
  },
  
 
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "sessions",
        loadChildren: () => import("./views/sessions/sessions.module").then((m) => m.SessionsModule),
      },
    ],
  },
  
  {
    path: "",
    component: BlankLayoutComponent,
    children: [
      {
        path: "others",
        loadChildren: () => import("./views/others/others.module").then((m) => m.OthersModule),
      },
    ],
  },
  {
    path: "",
    component: AdminLayoutSidebarLargeComponent,
    canActivate: [AuthGaurd],
    children: adminRoutes,
  },
  {
    path: "**",
    redirectTo: "others/404",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
